import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { WorkCompletionFormDTO } from '../models/work-completion-form-dto.model';

@Injectable({
  providedIn: 'root'
})
export class WorkCompletionFormService {

  constructor(private http: HttpServices) { }

  public getReadOnlyProperties (RequestId: string) {
    return this.http.get('WorkCompletionForm/GetRequestReadOnlyProperties/' + RequestId);
  }

  public AddWorkCompletionForm (completionForm: WorkCompletionFormDTO) {
    return this.http.post('WorkCompletionForm/AddWorkCompletionForm', completionForm);
  }

   getWorkCompletionForm (RequestId: string){
    return this.http.get('WorkCompletionForm/GetWorkCompletion/' + RequestId)
  }

}
